/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Sample_NoteInputs */

const ja_playdata_sample_note = /** @type {(inputs: Playdata_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFファイルが開きます。`)
};

const en_playdata_sample_note = /** @type {(inputs: Playdata_Sample_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicking the button will open a PDF file.`)
};

/**
* | output |
* | --- |
* | "Clicking the button will open a PDF file." |
*
* @param {Playdata_Sample_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_sample_note = /** @type {((inputs?: Playdata_Sample_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Sample_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_sample_note(inputs)
	return en_playdata_sample_note(inputs)
});